// plugins/loading.ts
import { useDownLoadLoading } from '~/composables/useDownLoadLoading'

export default defineNuxtPlugin(() => {
  const { downShow, downHide, setProgress } = useDownLoadLoading()

  return {
    provide: {
      downLoadLoading: {
        downShow,
        downHide,
        setProgress,
      },
    },
  }
})
